<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark v-bind="attrs" @click="newCampaign()">
        <v-icon left dense>mdi-plus</v-icon>
        Add campaign
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dark color="primary" dense>
        <v-toolbar-title>Campaign editor</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn text color="white" outlined light @click="save()">Save</v-btn>

          <!-- TODO: Not yet implemented
          <v-btn text color="white" outlined light @click="saveAndPublish()"
            >Publish</v-btn
          > -->

          <v-btn text color="white" light @click="clearAndClose()"
            >Discard</v-btn
          ></v-toolbar-items
        >
      </v-toolbar>
      <v-card-text class="pa-0">
        <v-row class="ma-0">
          <v-col class="b-r">
            <h2 class="mb-4">Basic settings</h2>
            <v-form ref="campaignForm">
              <v-text-field
                required
                label="Campaign title"
                placeholder="Enter campaign title"
                outlined
                v-model="campaign.title"
              ></v-text-field>
              <v-textarea
                required
                label="Description"
                placeholder="Campaign description"
                outlined
                v-model="campaign.description"
              ></v-textarea>
              <v-text-field
                required
                label="Logo URL"
                placeholder="https://"
                outlined
                v-model="campaign.imageUrl"
              ></v-text-field>
              <v-text-field
                required
                label="Link to info or landing page"
                placeholder="https://"
                outlined
                v-model="campaign.externalUrl"
              ></v-text-field>
              <v-text-field
                required
                label="Campaign identifier (displayed in URLs)"
                placeholder="campaign-identifier"
                outlined
                v-model="campaign.slug"
              ></v-text-field>
              <v-switch
                  label="User should accept campaign terms"
                  dense
                  inset
                  class="mt-0"
                  v-model="campaign.terms.show"
                ></v-switch>
              <v-text-field
                required
                label="Link to campaign terms"
                placeholder="https://"
                outlined
                v-model="campaign.terms.externalUrl"
                v-if="campaign.terms.show"
              ></v-text-field>
              <v-text-field
                required
                label="Terms title"
                placeholder="Title"
                outlined
                v-model="campaign.terms.title"
                v-if="campaign.terms.show"
              ></v-text-field>
              <v-textarea
                required
                label="Terms description"
                placeholder="Description"
                outlined
                v-model="campaign.terms.description"
                v-if="campaign.terms.show"
              ></v-textarea>
              <!-- <v-select
                :items="users"
                multiple
                label="Editors"
                outlined
                hint="Select users that can edit the campaign"
                v-model="campaign.editors"
                clearable
              >
              </v-select> -->
              <h2>Publishing settings</h2>
              <v-row>
                <v-col>
                  <v-menu
                    v-model="startDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="campaign.schedule.publish"
                        label="Start date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="campaign.schedule.publish"
                      @input="startDateMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col>
                  <v-menu
                    v-model="endDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="campaign.schedule.expire"
                        label="End date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="campaign.schedule.expire"
                      @input="endDateMenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-sheet>
                <v-switch
                  label="Hide campaign jobs from public listing"
                  dense
                  inset
                  class="mt-0"
                  v-model="campaign.privateJobs"
                ></v-switch>
                <v-switch
                  label="Campaign is published"
                  dense
                  inset
                  class="mt-0"
                  v-model="campaignStatus"
                ></v-switch>
              </v-sheet>
            </v-form>
          </v-col>
          <v-col class="b-r">
            <h2>Job selector</h2>
            <p>
              In this section you can choose which jobs to show in the campaign.
              You can either select an area and category to filter shown jobs,
              or you can pick or create single specific jobs to add to the campaign.
            </p>
            <v-switch v-model="specificJobs" label="Select or add specific jobs to campaign"></v-switch>
            <v-row v-if="!specificJobs">
              <v-col>
                <v-select
                  label="Select area"
                  outlined
                  :items="getAreas"
                  item-text="name"
                  item-value="id"
                  v-model="selectedAreas"
                  clearable
                ></v-select>
              </v-col>
              <v-col>
                <v-select
                  label="Select categories"
                  outlined
                  :items="getCategories"
                  v-model="selectedCategories"
                  clearable
                  item-text="name"
                  item-value="id"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="specificJobs" class="align-center">
              <v-col><h3>Pick single jobs</h3></v-col>
              <v-col><PositionNew /></v-col>
            </v-row>
            <v-row v-if="specificJobs">
              <v-text-field
                required
                placeholder="Job, company, category or area name"
                prepend-inner-icon="mdi-magnify"
                v-model="search"
              ></v-text-field>
            </v-row>
            <v-row v-if="specificJobs">
              <v-data-table
                :headers="headers"
                :items="getJobs"
                :items-per-page="10"
                :show-select="specificJobs"
                :search="search"
                style="width: 100%"
                v-model="selectedJobs"
              ></v-data-table>
            </v-row>
          </v-col>
          <v-col>
            <v-card>
              <div class="campaign-header pa-4">
                <!-- <img
                  :src="campaign.image"
                  style="max-width: 200px"
                  class="mb-4"
                /> -->
                <h2 class="mb-4">{{ campaign.title }}</h2>
                <p>{{ campaign.description }}</p>
                <v-btn v-if="campaign.externalUrl" text color="white">
                  Read more
                  <v-icon right dense>mdi-open-in-new</v-icon>
                </v-btn>
              </div>
              <v-data-table
                :headers="headers"
                :items="specificJobs ? selectedJobs : getJobs"
                :items-per-page="10"
                style="width: 100%"
              ></v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import PositionNew from "@/components/PositionNew.vue";

export default {
  components: {
    PositionNew,
  },
  props: [
    'editCampaign',
    'showDialog'
  ],
  data() {
    return {
      dialog: false,
      startDateMenu: false,
      endDateMenu: false,
      oldId: null,
      campaign: {
        id: "",
        title: "",
        description: "",
        imageUrl: "",
        externalUrl: "",
        terms: {
          show: false,
          title: '',
          description: '',
          externalUrl: ''
        },
        schedule: {
          publish: new Date().toISOString().substr(0, 10),
          expire: new Date().toISOString().substr(0, 10)
        },
        status: 'draft',
        privateJobs: false,
        filters: {
          areas: [],
          categories: [],
          tags: []
        },

        // created: null,
        // createdBy: null,
        // editors: [],
        // actions: null

        // startDate: new Date().toISOString().substr(0, 10),
        // endDate: new Date().toISOString().substr(0, 10),
        // hideJobs: false,
        // published: false,
        // showTerms: false,
        // termsDescription: '',
        // termsUrl: '',
      },
      selectedJobs: [],
      /* users: [
        {
          text: "John Smith",
          value: "d4f2b8ecaba9232703240d251c8ae0d9",
        },
        {
          text: "Peter Smith",
          value: "1be9d16fc710438e8297dc8404db0d22",
        },
        {
          text: "Julia Jakobsdottir",
          value: "e59beba04ef11c4d5852589d1d2f176d",
        },
        {
          text: "Valo Taivas",
          value: "82e54fa03b87878169ca4fe111b07096",
        },
        {
          text: "Pekka Pakkanen",
          value: "858c6d1e55161af71c0abfa1ba60dfab",
        },
        {
          text: "Riikka Rautanen",
          value: "6494fd7be6942b606057012406913971",
        },
      ], */
      headers: [
        { text: "Open position", value: "title" },
        { text: "Company", value: "employer.name" },
        { text: "Location", value: "location.city" },
      ],
      specificJobs: false,
      search: "",
      searchTerms: {
        keywords: "",
        area: "",
      }
    };
  },
  mounted(){
    this.$store.dispatch("dispatchGetUsers");
    console.log(this.$store.state.users);
    this.$store.dispatch("dispatchCategoriesWithDetails").then((cats) => console.log(cats));
  },
  watch: {
    editCampaign: function (newVal, oldVal) {
      console.log(newVal);
      console.log("current campaign: ", this.campaign);
      if(newVal !== null){
        this.oldId = newVal.id;
        this.campaign = newVal;

        // Populate campaign selected jobs on load if no cat filters and jobs exist
        if(
          this.campaign.filters.areas.length > 0 ||
          this.campaign.filters.categories.length > 0 ||
          this.campaign.filters.tags.length > 0
        ){
          this.specificJobs = false;
          this.selectedJobs = [];
        }
        else{

          this.$store.dispatch("dispatchGetCampaignJobs", { campaignId: newVal.id }).then((jobs) => {
          console.log("campaign jobs", jobs);
          if(jobs.length > 0){
            this.specificJobs = true;
            this.selectedJobs = jobs;
            console.log('clear filters');
            this.selectedCategories = null;
            this.selectedAreas = null;
          }
          else{
            this.specificJobs = false;
            this.selectedJobs = [];
          }
          });

        }
      }
    },
    showDialog: function (newVal, oldVal) {
      console.log(newVal);
      this.dialog = newVal;
      if(newVal && this.specificJobs){
        // Fetch jobs for picker
        this.fetchAllJobs();
      }
    },
    specificJobs: function (newVal, oldVal){
      if(newVal){
        // Fetch all jobs for picker
        this.fetchAllJobs();
      } else {
        // Fetch public jobs for preview
        this.$store.dispatch("dispatchGetJobs").then(() => {
          console.log("dispatchGetJobs done");
        });
      }
    }
  },
  methods: {
    save() {
      console.log(this.campaign);

      // Clean up
      if(this.specificJobs){ this.campaign.filters = { areas: [], categories: [], tags: [] } }
      if(this.campaign.filters.areas[0] == null) this.campaign.filters.areas = [];
      if(this.campaign.filters.categories[0] == null) this.campaign.filters.categories = [];
      if(this.campaign.filters.tags[0] == null) this.campaign.filters.tags = [];

      if(this.editCampaign !== undefined && this.oldId !== null){

        this.$store
          .dispatch("dispatchPutCampaign", { campaignData: this.campaign, id: this.oldId })
          .then(() => {
            

            // Commit job list to campaign, TODO: Fetch jobs on campaign load
            console.log(this.selectedJobs.map((job) => { return job.id }));
            this.$store
              .dispatch("dispatchPutAdminCampaignJobs", {
                campaignId: this.campaign.id,
                jobIds: this.selectedJobs.map((job) => { return job.id })
                });

            this.$store.dispatch("dispatchGetCampaigns");
            this.clearAndClose();
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        // Set campaign slug as id
        this.campaign.id = this.campaign.slug;

        this.$store
          .dispatch("dispatchPostCampaign", { campaignData: this.campaign })
          .then(() => {

            this.$store.dispatch("dispatchGetCampaigns");
            this.clearAndClose();
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    saveAndPublish() {},
    clearAndClose() {
      this.$emit("campaignCreated", this.campaign);
      this.dialog = false;
      this.clearCampaign();
      this.editCampaign = this.campaign;
    },
    newCampaign(){
      this.clearCampaign();
      this.dialog = true;
    },
    clearCampaign(){
      // Reset campaign object
      this.campaign = {
        id: "",
        title: "",
        description: "",
        imageUrl: "",
        externalUrl: "",
        terms: {
          show: false,
          title: '',
          description: '',
          externalUrl: ''
        },
        schedule: {
          publish: new Date().toISOString().substr(0, 10),
          expire: new Date().toISOString().substr(0, 10)
        },
        status: 'draft',
        privateJobs: false,
        filters: {
          areas: [],
          categories: [],
          tags: []
        }
      }
      this.specificJobs = false;
      this.search = "";
      this.searchTerms = {
        keywords: "",
        area: "",
      };
      this.selectedJobs = [];
      this.oldId = null;
    },
    fetchAllJobs() {
      this.$store.dispatch("dispatchGetJobsAdmin").then(() => {
        console.log("dispatchGetJobsAdmin done");
      });
    },
  },
  computed: {
    getJobs() {
      if(this.specificJobs){
        return this.$store.state.jobs;
      }
      else{
        console.log('getting search results');
        return this.$store.state.searchResults.filter((el) => el.match);
      }
    },
    getCategories() {
      return this.$store.state.categoriesWithDetails;
    },
    getAreas() {
      return this.$store.state.mapData;
    },
    users(){
      return this.$store.state.users.map(user => {
        return {
          text: user.firstName + ' ' + user.lastName,
          value: user.id
        }
      });
    },
    selectedAreas: {
      get(){
        return this.$store.state.searchTerms.area;
      },
      set(area){
        if(area !== null){
          let areaObject = this.$store.state.mapData.find((area) => area.id = area);
          this.searchTerms.area = areaObject.name;
          this.campaign.filters.areas = [ area ];
        }
        else{
          this.searchTerms.area = null;
          this.campaign.filters.areas = [];
        }
        this.$store.dispatch("commitSearchTerms", this.searchTerms);
        this.$store.dispatch("commitSearchResults", this.searchTerms);
      }
    },
    selectedCategories: {
      get(){
        return this.$store.state.searchTerms.keywords;
      },
      set(categories){
        if(categories !== null){
          this.searchTerms.keywords = categories;
          this.campaign.filters.categories = [ categories ];
        }
        else{
          this.searchTerms.keywords = null;
          this.campaign.filters.categories = [];
        }
        this.$store.dispatch("commitSearchTerms", this.searchTerms);
        this.$store.dispatch("commitSearchResults", this.searchTerms);
      }
    },
    campaignStatus: {
      get(){
        return this.campaign.status === 'published'
      },
      set(status) {
        this.campaign.status = status ? 'published' : 'draft'
      }
    }
  },
};
</script>
<style scoped>
h2 {
  color: rgba(0, 45, 160, 1);
}
.campaign-header {
  background: rgba(0, 45, 160, 1);
  color: #fff;
}
.campaign-header h2 {
  color: #fff;
  text-transform: uppercase;
  font-size: 24px;
}
.campaign-header p {
  font-size: 18px;
}
</style>